import {createAction} from "redux-actions";

export const requestStarted = createAction("REQUEST_STARTED");
export const requestFailed = createAction("REQUEST_FAILED");

export const requestSucceeded = createAction("REQUEST_SUCCEEDED");
export const didReceiveShops = createAction("RECEIVE_SHOPS");
export const invalidateShops = createAction("INVALIDATE_SHOPS");
export const setMyShopsFilter = createAction("SET_SHOPS_FILTER");


// shop profile actions
export const clearShopProfile = createAction("CLEAR_SHOP_PROFILE");
export const requestShopProfessionals = createAction("REQUEST_SHOP_PROFESSIONALS");
export const didReceiveShopProfessionals = createAction("RECEIVE_SHOP_PROFESSIONALS");
export const requestShopBooths = createAction("REQUEST_SHOP_BOOTHS");
export const didReceiveShopBooths = createAction("RECEIVE_SHOP_BOOTHS");
export const didAddShopBooth = createAction("ADD_SHOP_BOOTH");


// WEBPACK FOOTER //
// ./app/client/shop/actions.ts